// DO NOT EDIT -- generated from fs/services/llm-tool/llm-tool.proto

import { LlmModel, Role } from './llm.proto';
import * as pagemetrics from '../../api/metrics/pagemetrics';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';
import * as vars from '../../api/vars';

export namespace LlmToolPublic {

  export const RawPromptEndpoint = "/grpc/llm_tool.LlmToolPublic/RawPrompt";
  export function RawPrompt(sender: (req: RawPromptRequest, endpoint: string) => Promise<RawPromptResponse>, req: RawPromptRequest): { promise: () => Promise<RawPromptResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RawPromptEndpoint),
      endpoint: RawPromptEndpoint
    };
  }

  export const ClassifyFunnelEndpoint = "/grpc/llm_tool.LlmToolPublic/ClassifyFunnel";
  export function ClassifyFunnel(sender: (req: ClassifyFunnelRequest, endpoint: string) => Promise<ClassifyFunnelResponse>, req: ClassifyFunnelRequest): { promise: () => Promise<ClassifyFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ClassifyFunnelEndpoint),
      endpoint: ClassifyFunnelEndpoint
    };
  }

  export const FindCommonPathsEndpoint = "/grpc/llm_tool.LlmToolPublic/FindCommonPaths";
  export function FindCommonPaths(sender: (req: FindCommonPathsRequest, endpoint: string) => Promise<FindCommonPathsResponse>, req: FindCommonPathsRequest): { promise: () => Promise<FindCommonPathsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FindCommonPathsEndpoint),
      endpoint: FindCommonPathsEndpoint
    };
  }

  export const SuggestElementLabelSingleEndpoint = "/grpc/llm_tool.LlmToolPublic/SuggestElementLabelSingle";
  export function SuggestElementLabelSingle(sender: (req: SuggestElementLabelSingleRequest, endpoint: string) => Promise<SuggestLabelSingleResponse>, req: SuggestElementLabelSingleRequest): { promise: () => Promise<SuggestLabelSingleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SuggestElementLabelSingleEndpoint),
      endpoint: SuggestElementLabelSingleEndpoint
    };
  }

  export const SuggestPageLabelSingleEndpoint = "/grpc/llm_tool.LlmToolPublic/SuggestPageLabelSingle";
  export function SuggestPageLabelSingle(sender: (req: SuggestPageLabelSingleRequest, endpoint: string) => Promise<SuggestLabelSingleResponse>, req: SuggestPageLabelSingleRequest): { promise: () => Promise<SuggestLabelSingleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SuggestPageLabelSingleEndpoint),
      endpoint: SuggestPageLabelSingleEndpoint
    };
  }

  export const SuggestEventLabelSingleEndpoint = "/grpc/llm_tool.LlmToolPublic/SuggestEventLabelSingle";
  export function SuggestEventLabelSingle(sender: (req: SuggestEventLabelSingleRequest, endpoint: string) => Promise<SuggestLabelSingleResponse>, req: SuggestEventLabelSingleRequest): { promise: () => Promise<SuggestLabelSingleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SuggestEventLabelSingleEndpoint),
      endpoint: SuggestEventLabelSingleEndpoint
    };
  }

  export const SuggestPropertyLabelSingleEndpoint = "/grpc/llm_tool.LlmToolPublic/SuggestPropertyLabelSingle";
  export function SuggestPropertyLabelSingle(sender: (req: SuggestPropertyLabelSingleRequest, endpoint: string) => Promise<SuggestLabelSingleResponse>, req: SuggestPropertyLabelSingleRequest): { promise: () => Promise<SuggestLabelSingleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SuggestPropertyLabelSingleEndpoint),
      endpoint: SuggestPropertyLabelSingleEndpoint
    };
  }

  export const PrioritizeSelectorComponentsEndpoint = "/grpc/llm_tool.LlmToolPublic/PrioritizeSelectorComponents";
  export function PrioritizeSelectorComponents(sender: (req: PrioritizeSelectorComponentsRequest, endpoint: string) => Promise<PrioritizeSelectorComponentsResponse>, req: PrioritizeSelectorComponentsRequest): { promise: () => Promise<PrioritizeSelectorComponentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, PrioritizeSelectorComponentsEndpoint),
      endpoint: PrioritizeSelectorComponentsEndpoint
    };
  }

  export const TrimSelectorEndpoint = "/grpc/llm_tool.LlmToolPublic/TrimSelector";
  export function TrimSelector(sender: (req: TrimSelectorRequest, endpoint: string) => Promise<TrimSelectorResponse>, req: TrimSelectorRequest): { promise: () => Promise<TrimSelectorResponse>, endpoint: string } {
    return {
      promise: () => sender(req, TrimSelectorEndpoint),
      endpoint: TrimSelectorEndpoint
    };
  }

  export const DebugTrimSelectorEndpoint = "/grpc/llm_tool.LlmToolPublic/DebugTrimSelector";
  /**
   * Similar to TrimSelector, but without intermediate result streaming and with
   * debug logging to report trim candidates across processing steps.
   */
  export function DebugTrimSelector(sender: (req: TrimSelectorRequest, endpoint: string) => Promise<TrimSelectorResponse>, req: TrimSelectorRequest): { promise: () => Promise<TrimSelectorResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DebugTrimSelectorEndpoint),
      endpoint: DebugTrimSelectorEndpoint
    };
  }
}

export interface RawPromptRequest {
  prompt: string;
  llmModel: LlmModel;
  orgId: string;
}

export interface RawPromptResponse {
  response: string;
}

export interface LabelSuggestion {
  name: string;
  description: string;
}

export interface SuggestLabelSingleResponse {
  suggestion: LabelSuggestion | null;
}

export interface SuggestElementLabelSingleRequest {
  selector: string;
  /** if choices are supplied, pick one of the choices */
  choices: string[];
  orgId: string;
  /** if false, just use the selector as context */
  useAdditionalContext: boolean;
  /** if blocklist is provided, these names won't be generated */
  blocklist: string[];
}

export interface SuggestPageLabelSingleRequest {
  urlPattern: string;
  /** if choices are supplied, pick one of the choices */
  choices: string[];
  orgId: string;
  /** if false, just use the url_pattern as context */
  useAdditionalContext: boolean;
  /** if blocklist is provided, these names won't be generated */
  blocklist: string[];
}

export interface SuggestEventLabelSingleRequest {
  definedEvent: search_settings.DefinedEvent | null;
  /** if choices are supplied, pick one of the choices */
  choices: string[];
  orgId: string;
  /** if blocklist is provided, these names won't be generated */
  blocklist: string[];
}

export interface SuggestPropertyLabelSingleRequest {
  namedElementId: string;
  /** if choices are supplied, pick one of the choices */
  choices: string[];
  orgId: string;
  /** if blocklist is provided, these names won't be generated */
  blocklist: string[];
  propertyRule: SuggestPropertyLabelSingleRequest.PropertyRule | null;
}

export namespace SuggestPropertyLabelSingleRequest {
  export interface PropertyRule {
    propertyType: vars.Type;
    attribute?: search_settings.ElementPropertyRule.SourceAttribute | null;
    innerText?: search_settings.ElementPropertyRule.SourceInnerText | null;
    static?: search_settings.ElementPropertyRule.SourceStatic | null;
    sampleValues: string[];
    propertyRuleDescription: string;
  }

  export namespace PropertyRule {
    export enum source {
      attribute = 2,
      innerText = 3,
      static = 4
    }

    export function source_oneof(m: PropertyRule): { opt: source.attribute, val: search_settings.ElementPropertyRule.SourceAttribute } | { opt: source.innerText, val: search_settings.ElementPropertyRule.SourceInnerText } | { opt: source.static, val: search_settings.ElementPropertyRule.SourceStatic } | null {
      if (m.attribute != null) { return { opt: source.attribute, val: m.attribute } }
      if (m.innerText != null) { return { opt: source.innerText, val: m.innerText } }
      if (m.static != null) { return { opt: source.static, val: m.static } }
      return null;
    }
  }
}

export interface ClassifyFunnelRequest {
  steps: string[];
}

export interface ClassifyFunnelResponse {
  description: string;
  category: string;
  importance: number;
}

export interface CommonPathOptions {
  /**
   * If set, will exclude funnels that are a pure subset of another funnel.
   * In other words, any funnel whose steps are a contiguous sequence of a
   * _longer_ funnel's steps will be excluded.
   */
  excludeSubsets: boolean;
  /**
   * If set, will only return funnels in which the number of events is greater
   * than or equal to this value.
   */
  minLength: number;
  /**
   * If set, will only return funnels in which each step's completion rate is
   * greater than or equal to this value.
   */
  minThreshold: number;
}

export interface JourneyMapNode {
  depth: number;
  event: segment.Event | null;
  interactionData: pagemetrics.JourneyMap.InteractionData | null;
}

export interface JourneyMapPath {
  completionRate: number;
  constraints: segment.Constraints | null;
  nodes: JourneyMapNode[];
}

export interface FindCommonPathsRequest {
  journeyMap: pagemetrics.JourneyMap | null;
  constraints: segment.JourneyMapConstraints | null;
  options: CommonPathOptions | null;
  eventIdent: segment.EventIdent | null;
}

export interface FindCommonPathsResponse {
  results: JourneyMapPath[];
}

export interface PrioritizeSelectorComponentsRequest {
  elementName: string;
  selector: string;
  orgId: string;
}

export interface PrioritizeSelectorComponentsResponse {
  priorities: PrioritizeSelectorComponentsResponse.ComponentPriority[];
}

export namespace PrioritizeSelectorComponentsResponse {
  export interface ComponentPriority {
    token: string;
    priority: string;
  }
}

export enum Feature {
  FEATURE_INVALID = 0,
  FEATURE_SESSION_SUMMARY = 1,
  FEATURE_SUMMARY_API = 10,
  FEATURE_SUGGESTED_ELEMENTS = 2,
  FEATURE_GEN_METRIC = 3,
  FEATURE_EXPERIMENT = 4,
  FEATURE_OBJECT_LABELS = 5,
  FEATURE_BULK_SESSION_SUMMARY = 6,
  FEATURE_STORYAI_OPPORTUNITIES = 7,
  FEATURE_CHATFORCE = 8,
  FEATURE_STORYAI_ANSWERS = 9,
  FEATURE_AI_PAGE_SUGGESTIONS = 11,
  FEATURE_ANONYMIZE = 12,
  FEATURE_TRANSLATE = 13,
  FEATURE_AI_SELECTOR_TRIM = 14
}

/**
 * ChatMessageLog is used for logging compatible with fseventlogger. Structured
 * logs do not allow nested repeated fields, which the "Parts" contain. Usually,
 * there will only be one "Part", so this is generally accurate, but may lose
 * ordering in cases where there are multiple string parts.
 */
export interface ChatMessageLog {
  role: Role;
  content: string;
}

export interface TemplateVariable {
  name: string;
  value: string;
}

export interface EventLog {
  orgId: string;
  /**
   * LLM request steps for a single execution/agent run should map to the same
   * trace_id
   */
  traceId: string;
  /** Unique identifier for the run within the trace */
  runId: string;
  /** Nested runners link to their direct parent run id */
  parentTraceId: string;
  /** The stringified feature enum */
  feature: string;
  /** RunType distinguishes different categories of executions (llm, tool, etc). */
  runType: string;
  /**
   * Optional, use if the feature has more than one strategy/method to choose
   * from
   */
  method: string;
  /**
   * Name of the step (ex. "FetchObjects", "ClassifyInput") of the execution the
   * run is for within the multi-run trace
   */
  step: string;
  /** The stringified LLM model */
  model: string;
  /** Input/output messages */
  promptInputs: ChatMessageLog[];
  promptOutput: string;
  inputTokenCount: number;
  outputTokenCount: number;
  /** Request duration in milliseconds */
  duration: number;
  /** Optional, for logging any relevant intermediate structs used or parsed */
  miscJsonObjects: string[];
  timestamp: protobuf.timestamp | null;
  /** if it failed, this will contain the error message */
  error: string;
  /**
   * For prompt template steps, the data used to substitute placeholder values (deprecated, use run_input instead)
   * 
   * @deprecated
   */
  templateVariables: TemplateVariable[];
  runInput: string[];
  runMetadata: string[];
}

export interface TrimSelectorRequest {
  orgId: string;
  selector: string;
  nativePlatforms: segment.NativePlatform[];
}

export interface TrimSelectorResponse {
  selector: string;
}
